module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-plan-image-dc4c8e5a284c459e555a711b95db26dd.png";